module.exports = __webpack_public_path__ + "img/report-7.6778a55c.jpg";